// useMarkPaymentPaid — DRY: the "mark paid" action shared by the dashboard's recent-payments row, the
// student detail page's payments row and the Payments page. A manual confirmation through the one verify
// path (see useVerifyPayment); it carries proof, which the server validates. Only valid for a payment with
// no student code, so callers show the control only when reference is null.
import { useVerifyPayment } from "./useVerifyPayment.js";
import type { ManualProofInput } from "@dm-lms/shared/validations";
import type { Payment, PaymentWithProof } from "@dm-lms/shared/types";

// The proof fields of a manual confirmation, whichever branch (Omit alone would collapse the union).
type ProofFields = ManualProofInput extends infer T ? (T extends unknown ? Omit<T, "manual"> : never) : never;

export function useMarkPaymentPaid(payment: Pick<Payment, "id">, onPaid: (payment: PaymentWithProof) => void) {
  const { isSubmitting, error, verify } = useVerifyPayment(payment.id, onPaid);

  // Resolves true when the payment was confirmed; false leaves `error` set.
  async function markPaid(proof: ProofFields): Promise<boolean> {
    const result = await verify({ manual: true, ...proof } as ManualProofInput);
    return result?.match === true;
  }

  return { isSubmitting, error, markPaid };
}
